var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, TextField } from '@mui/material';
import { getIn } from 'formik';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState, useCallback } from 'react';
import { FieldIcons } from './Icons';
import { toUpperCaseFirstChar } from '../theme';
export var TYPES = {
    TEXT: 'text',
    BOOLEAN: 'boolean',
    SELECT: 'select',
};
export var fieldToTextField = function (props) {
    var field = props.field, form = props.form, disabled = props.disabled, afterChange = props.afterChange, onlyDigits = props.onlyDigits, smallerThanZero = props.smallerThanZero, datePicker = props.datePicker, datetimePicker = props.datetimePicker, _a = props.uppercase, uppercase = _a === void 0 ? false : _a, _b = props.uppercaseFirstChar, uppercaseFirstChar = _b === void 0 ? false : _b, _c = props.onlyMonth, onlyMonth = _c === void 0 ? false : _c, _d = props.multiple, multiple = _d === void 0 ? false : _d, additionnalProps = __rest(props, ["field", "form", "disabled", "afterChange", "onlyDigits", "smallerThanZero", "datePicker", "datetimePicker", "uppercase", "uppercaseFirstChar", "onlyMonth", "multiple"]);
    var name = field.name;
    var isSubmitting = form.isSubmitting, errors = form.errors, setFieldValue = form.setFieldValue;
    var fieldError = getIn(errors, name);
    var showError = !!fieldError;
    var returnProps = __assign(__assign(__assign({}, additionnalProps), field), { disabled: disabled !== undefined ? disabled : isSubmitting, error: !!showError });
    if (showError) {
        returnProps.helperText =
            (datePicker || datetimePicker) && returnProps.value
                ? 'Date invalide'
                : fieldError;
    }
    if (returnProps.value === undefined || returnProps.value === null) {
        if (props.type !== TYPES.SELECT && !datePicker && !datetimePicker) {
            returnProps.value = onlyDigits ? 0 : '';
        }
        else {
            returnProps.value = multiple ? [] : null;
        }
    }
    var handleChange;
    if (props.type === TYPES.SELECT) {
        if (multiple) {
            returnProps.multiple = true;
            handleChange = function (e, option) {
                var value = option ? option.map(function (_a) {
                    var value = _a.value;
                    return value;
                }) : null;
                setFieldValue(name, value);
                setFieldValue(name + '__options', option);
                return value;
            };
        }
        else {
            handleChange = function (e, option) {
                var value = option ? option.value : null;
                setFieldValue(name, value);
                setFieldValue(name + '__options', option);
                return value;
            };
        }
    }
    else if (onlyDigits) {
        handleChange = function (e) {
            var value = e.target.value;
            var isNegative = false;
            if (smallerThanZero && value.startsWith('-')) {
                isNegative = true;
            }
            value = value.replace(/[^\d+.\d+]/g, '').replace(',', '.');
            if (value.split('.').length > 2 ||
                (value.includes('.') && value.split('.')[1].length > 2)) {
                return;
            }
            if (value.length > 1 &&
                value.startsWith('0') &&
                !value.startsWith('0.')) {
                value = value.substring(1, value.length);
            }
            if (isNegative) {
                value = '-' + value;
            }
            setFieldValue(name, value);
            return parseFloat(value);
        };
    }
    else if (datePicker || datetimePicker) {
        handleChange = function (newValue) {
            setFieldValue(name, newValue);
            return newValue;
        };
    }
    else {
        handleChange = function (e) {
            var value = e.target.value;
            if (value) {
                if (uppercaseFirstChar) {
                    value = toUpperCaseFirstChar(value);
                }
                if (uppercase) {
                    value = value.toUpperCase();
                }
            }
            setFieldValue(name, value);
            return value;
        };
    }
    if (afterChange) {
        returnProps.onChange = function (e, option) {
            var value = handleChange(e, option);
            afterChange(value);
        };
    }
    else {
        returnProps.onChange = handleChange;
    }
    var iconName = name && name.endsWith('TypeId')
        ? 'TypeId'
        : name.includes('.')
            ? name.split('.')[1]
            : name;
    if (name && !props.InputProps && FieldIcons[iconName]) {
        var FieldIcon = FieldIcons[iconName];
        returnProps.InputProps = {
            startAdornment: (_jsx(FieldIcon, { className: "mr-small", color: "primary", fontSize: "small" })),
        };
    }
    for (var _i = 0, _e = Object.keys(returnProps); _i < _e.length; _i++) {
        var key = _e[_i];
        if (returnProps[key] === undefined) {
            delete returnProps[key];
        }
    }
    return returnProps;
};
export var FormikTextField = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    if (props.datePicker || props.datetimePicker) {
        var _b = __assign({}, fieldToTextField(props)), _c = _b.label, label = _c === void 0 ? null : _c, _d = _b.disabled, disabled = _d === void 0 ? false : _d, _e = _b.onChange, onChange = _e === void 0 ? null : _e, _f = _b.value, value = _f === void 0 ? null : _f, propsInputDatePicker_1 = __rest(_b, ["label", "disabled", "onChange", "value"]);
        var ComponentDate = props.datetimePicker ? DateTimePicker : DatePicker;
        return (_jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: _jsx(ComponentDate, { label: label, inputFormat: props.datetimePicker ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY', value: value, disabled: disabled, onChange: onChange, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, propsInputDatePicker_1, { InputProps: __assign(__assign({}, (params.InputProps ? params.InputProps : {})), (propsInputDatePicker_1.InputProps
                        ? propsInputDatePicker_1.InputProps
                        : {})), variant: "standard" }))); }, ampmInClock: false, ampm: false }) })));
    }
    if (props.type === TYPES.SELECT) {
        var _g = useState([]), asyncOptions = _g[0], setAsyncOptions_1 = _g[1];
        var _h = useState(true), loading = _h[0], setLoading_1 = _h[1];
        var _j = useState(null), timeoutId_1 = _j[0], setTimeoutId_1 = _j[1];
        var getDatas_1 = useCallback(function (search) {
            if (search === void 0) { search = null; }
            return __awaiter(void 0, void 0, void 0, function () {
                var newOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!props.handleAsyncOptions) return [3 /*break*/, 2];
                            setLoading_1(true);
                            return [4 /*yield*/, props.handleAsyncOptions(search)];
                        case 1:
                            newOptions = _a.sent();
                            setAsyncOptions_1(newOptions ? newOptions : []);
                            setLoading_1(false);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }, []);
        useEffect(function () {
            getDatas_1();
        }, []);
        var _k = __assign({}, fieldToTextField(props)), _l = _k.error, error_1 = _l === void 0 ? null : _l, _m = _k.InputProps, InputProps_1 = _m === void 0 ? null : _m, _o = _k.label, label_1 = _o === void 0 ? null : _o, _p = _k.options, options = _p === void 0 ? [] : _p, _q = _k.disabled, disabled = _q === void 0 ? false : _q, _r = _k.onChange, onChange = _r === void 0 ? null : _r, _s = _k.handleAsyncOptions, handleAsyncOptions = _s === void 0 ? null : _s, _t = _k.value, value_1 = _t === void 0 ? null : _t, _u = _k.multiple, multiple = _u === void 0 ? false : _u, propsAutocomplete_1 = __rest(_k, ["error", "InputProps", "label", "options", "disabled", "onChange", "handleAsyncOptions", "value", "multiple"]);
        if (!options) {
            options = [];
        }
        return (_jsx(Autocomplete, { fullWidth: true, multiple: multiple, onChange: onChange, onInputChange: handleAsyncOptions
                ? function (e, valueSearch) {
                    setLoading_1(true);
                    if (timeoutId_1) {
                        clearTimeout(timeoutId_1);
                    }
                    setTimeoutId_1(setTimeout(function () { return getDatas_1(valueSearch); }, 1000));
                }
                : null, disabled: disabled, options: handleAsyncOptions
                ? asyncOptions
                : options.filter(function (option) {
                    return option.show === undefined || option.show(option.params);
                }), value: value_1
                ? handleAsyncOptions
                    ? asyncOptions.find(function (option) { return option.value === value_1; })
                    : multiple
                        ? options.filter(function (option) { return value_1.includes(option.value); })
                        : options.find(function (option) { return option.value === value_1; })
                : null, getOptionLabel: function (option) { var _a; return (_a = option.label) !== null && _a !== void 0 ? _a : option; }, loading: loading, loadingText: "Recherche en cours...", noOptionsText: "Aucun r\u00E9sultat", renderInput: function (params) { return (_jsx(TextField, __assign({}, params, propsAutocomplete_1, { autoComplete: "off", InputProps: __assign(__assign(__assign({}, params.InputProps), InputProps_1), { startAdornment: (_jsxs(_Fragment, { children: [InputProps_1 &&
                                InputProps_1.startAdornment &&
                                InputProps_1.startAdornment, params.InputProps &&
                                params.InputProps.startAdornment &&
                                params.InputProps.startAdornment] })) }), error: error_1, label: label_1, fullWidth: true, variant: "standard" }))); } }));
    }
    return (_jsx(TextField, __assign({ fullWidth: true, inputProps: {
            form: {
                autocomplete: 'off',
            },
        } }, fieldToTextField(props), { variant: "standard" }, { children: children })));
};
//# sourceMappingURL=FormikTextField.js.map